import React from "react";
import Box from "@mui/material/Box";
import Projectcolors from "../Utils/Colors";
import { baseURL } from "../Config/config";
import { Typography, Link } from "@mui/material";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import { Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import OutlinedInput from "@mui/material/OutlinedInput";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import model from "../images/model.png";
import Arrow from "../images/arrow.png";

import Excel from "../images/excel.jpeg";
import Hysys from "../images/hysys.jpeg";
import Gui from "../images/optimize.jpeg";
import jsonimage from "../images/json.png";

import { makeStyles } from "@mui/styles";
import GlobalLoader from "./CommonC/GlobalLoader";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import LinearProgress from "@mui/material/LinearProgress";
import PropTypes from "prop-types";
import axios from "axios";

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          sx={{ fontSize: 14 }}
          color="text.secondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

const useStyles = makeStyles({
  button: {
    textTransform: "none",
  },
});

function Deploy(props) {
  const [independent, setIndependent] = React.useState([]);
  const [dependent, setDependent] = React.useState([]);
  const [values, setValues] = React.useState([]);
  const [getvalues, setgetValues] = React.useState([]);
  const [predicted, setPredicted] = React.useState([]);
  const [unitsin, setunitsin] = React.useState([]);
  const [unitsde, setunitsde] = React.useState([]);
  const [minimum, setminimum] = React.useState([]);
  const [maximum, setmaximum] = React.useState([]);
  const [isCompleted, setisCompleted] = React.useState(false);

  const [modalTraining, setmodalTraining] = React.useState(false);
  const [getLoader, setGetLoader] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [inputopen, setinputOpen] = React.useState(false);
  const [errdownload, seterrdownload] = React.useState(false);
  const [mess, setmess] = React.useState(false);
  const [fpmess, setfpmess] = React.useState(false);
  const [falsewarning, setfalsewarning] = React.useState(false);
  const [timeseries, settimeseries] = React.useState(0);
  const [date, setDate] = React.useState("");
  const [progress, setProgress] = React.useState(0);
  const [trained, setTrained] = React.useState(false);
  const [selectedsnapshot, setselectedsnapshot] = React.useState(0);
  const [snapdetails, setsnapdetails] = React.useState([]);
  const [cat, setcat] = React.useState([]);
  const [fp, setfp] = React.useState([])
  const [usefp, setusefp] = React.useState(false)

  const handledateChange = (event) => {
    setDate(event.target.value);
    console.log(event.target.value);
    const dataArray = Array.from(values);
    dataArray[0] = event.target.value;
    setValues(dataArray);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    seterrdownload(false);
  };

  const handleermessageOpen = () => {
    setmess(true);
  };
  const handleMessage = () => {
    setmess(false);
    seterrdownload(false);
  };
  const handlefpMessage = () => {
    setfpmess(false);
    seterrdownload(false);
  };

  const handleallClose = () => {
    setinputOpen(false);
    seterrdownload(false);
  };

  const handleerrClickOpen = () => {
    seterrdownload(true);
  };

  const handleerrClose = () => {
    seterrdownload(false);
  };

  const handlefalsewarningOpen = () => {
    setfalsewarning(true);
  };

  const handlefalsewarningClose = () => {
    setfalsewarning(false);
  };

  React.useEffect(() => {
    getDeployData();
    
  }, []);

  

  const getDeployData = () => {
    setGetLoader(true);
    if (props.loaded) {
      sessionStorage.setItem("projectID", props.ProjectID);
    }
    const projectID = sessionStorage.getItem("projectID");
    fetch(
      `${baseURL}/getdeploydata?projectID=${projectID}&loaded=${props.loaded}`
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("data", data);
        if (data.predicted) {
          setPredicted(data.predicted);
          setgetValues(data.values);

          setValues(data.values);
        }
        setIndependent(data.independent);
        setDependent(data.dependent);
        setunitsin(data.unitsin);
        setunitsde(data.unitsde);
        setminimum(data.minimum);
        setmaximum(data.maximum);
        setisCompleted(data.isCompleted);
        settimeseries(data.timeseries);
        setusefp(data.usefp);
        setGetLoader(false);
        setselectedsnapshot(data.selectedsnapshot);
        setsnapdetails(data.snapdetails);
        setcat(data.cat);
        console.log(data);
        const projectID = sessionStorage.getItem("projectID");
        console.log("dataaaaaaa usefp",data.usefp)
        if(data.usefp == true){
          fetch(
            `${baseURL}/getfpData?projectID=${projectID}&loaded=${props.loaded}`
          )
            .then((res) => res.json())
            .then((data) => {
              
              setGetLoader(false);
              if (data.saved == 1){
                console.log("fp in sensitivity", data.fp);
                setfp(data.fp);
              }
  
              
            })
            .catch((err) => {
              setGetLoader(false);
            });
        }
        













      })
      .catch((err) => {
        setGetLoader(false);
      });
  };

  const handleChange = (event, idx) => {
    const dataArray = Array.from(values);
    dataArray[idx] = event.target.value;
    setValues(dataArray);
  };

  function checkinput() {
    var isnulll = false;
    if (values.length === 0 || values.length < independent.length) {
      setinputOpen(true);
      isnulll = true;
    }
    if (values.length === independent.length) {
      for (var i = 0; i < values.length; i++) {
        if (values[i] === "" || values[i] === null) {
          setinputOpen(true);
          isnulll = true;
        }
      }
    }
    if (isnulll === false) {
      predict();
    }
  }
  let timer;
  const predict = () => {
    const projectID = sessionStorage.getItem("projectID");
    console.log("In predict");
    console.log(date);
    const body = JSON.stringify({
      dependent,
      values,
      projectID,
      time: new Date(),
    });
    setProgress(0);
    setTrained(false);
    setmodalTraining(true);
    const config = {
      onUploadProgress: (progressEvent) => {
        let seconds = 1000;
        timer = setInterval(() => {
          setProgress((prevProgress) =>
            prevProgress >= 99 ? 99 : prevProgress + 1
          );
        }, seconds);
      },
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios
      .post(`${baseURL}/predict?projectID=${projectID}`, body, config)
      .then((response) => response)
      .then((result) => {
        const data = result.data;
        if(data.message === "error")
        {
          setfpmess(true);
          setmodalTraining(false);
          clearInterval(timer);
          setTrained(false);

        }
        if (data.message === "timeserieserror") {
          setmess(true);
          setmodalTraining(false);
          clearInterval(timer);
          setTrained(false);
        } else if (data.predicted) {
          setPredicted(data.predicted);
          setmodalTraining(false);
          clearInterval(timer);
          setTrained(true);
          setProgress(100);
        } else {
          setfalsewarning(true);
          setmodalTraining(false);
          clearInterval(timer);
          setTrained(false);
        }
      })
      .catch((error) => {
        if (mess === false) {
          setfalsewarning(true);
        }
        clearInterval(timer);
        setTrained(false);

        setmodalTraining(false);
        console.error("Error:", error);
      });
  };

  function downloadReport() {
    const projectID = sessionStorage.getItem("projectID");
    const projectName = sessionStorage.getItem("projectName");
    setGetLoader(true);
    fetch(`${baseURL}/getreportdata?projectID=${projectID}`)
      .then((res) => res.blob())
      .then((blob) => {
        var file = new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var url = URL.createObjectURL(file);
        var link = document.createElement("a");
        link.download = projectName + ".xlsx";
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        fetch(`${baseURL}/deletefile?projectName=${projectName}`, {
          method: "POST",
          body: JSON.stringify(projectName),
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((result) => {
            setGetLoader(false);
          })
          .catch((error) => {
            console.error("Error:", error);
            setGetLoader(false);
          });
        setGetLoader(false);
      })
      .catch((err) => {
        setGetLoader(false);
        seterrdownload(true);
        console.log("Error", err);
      });
  }


  function downloadHysysFolder(){
    const projectID = sessionStorage.getItem("projectID");
    const projectName = sessionStorage.getItem("projectName");

    const user_token = sessionStorage.getItem("usertoken");
    setGetLoader(true);
    fetch(`${baseURL}/gethysyszipfile?projectID=${projectID}&user_token=${user_token}`)
      .then((res) => res.blob())
      .then((blob) => {
        var file = new Blob([blob]);
        var url = URL.createObjectURL(file);
        var link = document.createElement("a");
        link.download = projectName +".zip";
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        fetch(`${baseURL}/deletehysysfile?projectName=${projectName}`, {
          method: "POST",
          body: JSON.stringify(projectName),
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((result) => {
            setGetLoader(false);
          })
          .catch((error) => {
            console.error("In delete file Error:", error);
            seterrdownload(true);
            setGetLoader(false);
          });
        setGetLoader(false);
        /**
        var file = new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var url = URL.createObjectURL(file);
        var link = document.createElement("a");
        link.download = projectName + ".zip";
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setGetLoader(false);
        */

      })
      
      .catch((err) => {
        setGetLoader(false);
        seterrdownload(true);
        console.log("Error", err);
      });

  }


  function downloadExec(timeseries){
    const projectID = sessionStorage.getItem("projectID");
    const projectName = sessionStorage.getItem("projectName");

    const user_token = sessionStorage.getItem("usertoken");
    setGetLoader(true);
    fetch(`${baseURL}/getexeczipfile?projectID=${projectID}&user_token=${user_token}&timeseries=${timeseries}`)
      .then((res) => res.blob())
      .then((blob) => {
        var file = new Blob([blob],{
          type: "application/json",
        });
        console.log(file)
        var url = URL.createObjectURL(file);
        console.log(url)
        var link = document.createElement("a");
        console.log(link)
        link.download = projectName +".json";
        link.href = url;
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        fetch(`${baseURL}/deleteexefile?projectName=${projectName}`, {
          method: "POST",
          body: JSON.stringify(projectName),
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((result) => {
            setGetLoader(false);
          })
          .catch((error) => {
            console.error("In delete exe file Error:", error);
            seterrdownload(true);
            setGetLoader(false);
          });
        setGetLoader(false);
        
      })

      
      .catch((err) => {
        setGetLoader(false);
        seterrdownload(true);
        console.log("Error", err);
      });

      /**
      .then((blob) => {
        
        var file = new Blob([blob]);
        var url = URL.createObjectURL(file);
        var link = document.createElement("a");
        link.download = projectName +".zip";
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        setGetLoader(false);
        
      }) */
      

  }


  /**
  function downloadGui(){
    const projectID = sessionStorage.getItem("projectID");
    const projectName = sessionStorage.getItem("projectName");

    const user_token = sessionStorage.getItem("usertoken");
    setGetLoader(true);
    fetch(`${baseURL}/getguizipfile?projectID=${projectID}&user_token=${user_token}`)
      .then((res) => res.blob())
      .then((blob) => {
        var file = new Blob([blob]);
        console.log(file)
        var url = URL.createObjectURL(file);
        console.log(url)
        var link = document.createElement("a");
        console.log(link)
        
        //link.download = "Gui.zip";
        //link.href = url;
        link.href="https://drive.google.com/file/d/1Vue_PQybI0MV1GbpqO-UvQBougGju2Ar/view?usp=sharing"
        
        document.body.appendChild(link);
        link.click();
        //  link.href, '   ');
        
        document.body.removeChild(link);
        setGetLoader(false);
        
      })

      
      .catch((err) => {
        setGetLoader(false);
        seterrdownload(true);
        console.log("Error", err);
      });

      
      .then((blob) => {
        
        var file = new Blob([blob]);
        var url = URL.createObjectURL(file);
        var link = document.createElement("a");
        link.download = projectName +".zip";
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        setGetLoader(false);
        
      }) 
      

  }
  */




      /**
      .then((blob) => {
        
        var file = new Blob([blob]);
        var url = URL.createObjectURL(file);
        var link = document.createElement("a");
        link.download = projectName +".zip";
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        setGetLoader(false);
        
      }) */
      

  

  const classes = useStyles();
  const cardStyle = {
  borderRadius: "22px",
  border: "1px solid #d9e9f7",
  background: "linear-gradient(to bottom,#ffffff,#fbfcff)",
  boxShadow: "0 8px 25px rgba(0,120,201,.08)",
};

  const cardStyle2 = {
  borderRadius: "22px",
  border: "1px solid #0078c9",
  background: "linear-gradient(to bottom,#ffffff,#fbfcff)",
  boxShadow: "0 8px 25px rgba(0,120,201,.08)",
};

const sectionTitleStyle = {
  position: "absolute",
  top: -16,
  left: 20,
  px: 2,
  py: 0.8,
  borderRadius: "20px",
  background: "#0078c9",
  color: "#fff",
  fontWeight: 600,
  fontSize: 13,
  zIndex: 2,
};

const inputStyle = {
  width: "135px",
  height: "34px",
  fontSize: "12px",
  borderRadius: "12px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#0078c9",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#9e0b22",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#0078c9",
  },
};

const actionLinkStyle = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#0078c9",
  textTransform: "none",
  display: "inline-flex",
  alignItems: "center",
  gap: 0.7,
  cursor: "pointer",
  px: 1.5,
  py: 0.8,
  borderRadius: "12px",
  border: "1px solid #d9e9f7",
  background: "#f8fbff",
  "&:hover": {
    color: "#9e0b22",
    background: "#fff",
  },
};

return (
  <Box sx={{ mt: "1px" }}>
    {/* Dialogs */}
    {[
      {
        open: falsewarning,
        close: handlefalsewarningClose,
        text: "Prediction Failed",
      },
      {
        open: inputopen,
        close: handleallClose,
        text: "All Inputs require to predict new values",
      },
      {
        open: errdownload,
        close: handleerrClose,
        text: "Error Downloading !",
      },
      {
        open: mess,
        close: handleMessage,
        text: "The Given Date is out of Training Data Sample",
      },
      {
        open: fpmess,
        close: handlefpMessage,
        text: "Please Fix First Principles Calculations",
      },
      {
        open: open,
        close: handleClose,
        text: "Incomplete Project ! Project Report Cannot be Downloaded",
      },
    ].map((d, i) => (
      <Dialog key={i} open={d.open} onClose={d.close}>
        <DialogTitle sx={{ color: "red", fontSize: "13px" }}>
          {d.text}
        </DialogTitle>
      </Dialog>
    ))}

    <Box sx={{ display: "flex", gap: 3, mt: 1 }}>
      {/* MAIN CARD */}
      <Paper
        elevation={0}
        sx={{
          ...cardStyle,
          height: 515,
          width: 1390,
          p: 2.5,
          display: "flex",
          gap: 2,
          border:"1px solid #0078c9"
        }}
      >
        {/* MIN MAX TABLE */}
        <Paper
          elevation={0}
          sx={{
            width: 330,
            height: 460,
            borderRadius: "18px",
            overflow: "hidden",
            border: "1px solid #d9e9f7",
          }}
        >
          <TableContainer sx={{ height: 460 }}>
            <Table stickyHeader sx={{ minWidth: 295 }}>
              <TableHead>
                <TableRow>
                  {["Variable", "Minimum", "Maximum"].map((head) => (
                    <TableCell
                      key={head}
                      align="center"
                      sx={{
                        fontSize: "12px",
                        color: "white",
                        bgcolor: Projectcolors.primary,
                        fontWeight: 600,
                      }}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {minimum
                  ? minimum.map((row, i) => (
                      <TableRow
                        key={i}
                        sx={{
                          "&:hover": { bgcolor: "#f8fbff" },
                          "& td": {
                            fontSize: "10px",
                            borderBottom: "1px solid #edf4fa",
                          },
                        }}
                      >
                        <TableCell align="center">{independent[i]}</TableCell>
                        <TableCell align="center">{row}</TableCell>
                        <TableCell align="center">{maximum[i]}</TableCell>
                      </TableRow>
                    ))
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* CENTER AREA */}
        <Box sx={{ width: 1030, height: 450 }}>
          {/* DOWNLOAD LINKS */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
              flexWrap: "wrap",
              mb: 2,
            }}
          >
            {isCompleted ? (
              <>
                <Link onClick={downloadReport} sx={actionLinkStyle}>
                  <img alt="excel" src={Excel} style={{ width: 24, height: 24 }} />
                  Download Project Report
                </Link>

                <Link
                  onClick={() => downloadExec(timeseries ? 1 : 0)}
                  sx={actionLinkStyle}
                >
                  <img
                    alt="json"
                    src={jsonimage}
                    style={{ width: 22, height: 22 }}
                  />
                  {timeseries
                    ? "Download JSON File for Timeseries"
                    : "Download JSON File"}
                </Link>

                {!timeseries && (
                  <Link
                    sx={actionLinkStyle}
                    href="https://drive.google.com/file/d/1Kq4nx5KveRsCcuXrXDNUsg18S7SRMqv-/view?usp=sharing"
                     
                  >
                    <img alt="gui" src={Gui} style={{ width: 26, height: 22 }} />
                    Download Predictable GUI
                  </Link>
                )}
              </>
            ) : (
              <Link onClick={handleClickOpen} sx={actionLinkStyle}>
                <img alt="excel" src={Excel} style={{ width: 24, height: 24 }} />
                Download Project Report
              </Link>
            )}
          </Box>

          {/* MODEL FLOW */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "stretch",
              justifyContent: "center",
              mt: 3,
            }}
          >
            {/* INDEPENDENT VARIABLES */}
            <Paper
              elevation={0}
              sx={{
                ...cardStyle,
                position: "relative",
                width: 250,
                height: 330,
                p: 2,
                pt: 5,
              }}
            >
              <Box sx={sectionTitleStyle}>Independent Variables</Box>

              <Box sx={{ height: 275, overflowY: "auto", pr: 1 }}>
                {(getvalues.length
                  ? fp.length > 0
                    ? fp[0]
                    : independent
                  : fp.length > 0
                  ? fp[0]
                  : independent
                ).map((item, i) => (
                  <FormControl
                    key={i}
                    sx={{ width: "100%", mb: 2 }}
                    size="small"
                  >
                    <Typography sx={{ fontSize: 11, mb: 0.6 }}>
                      {fp.length > 0
                        ? item[1]
                        : `${independent[i]}(${unitsin[i]})`}
                    </Typography>

                    {timeseries ? (
                      <TextField
                        type="datetime-local"
                        defaultValue={getvalues[i]}
                        onChange={handledateChange}
                        size="small"
                        sx={{
                          width: "170px",
                          "& .MuiOutlinedInput-root": inputStyle,
                        }}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ step: 1 }}
                      />
                    ) : (
                      <OutlinedInput
                        defaultValue={getvalues[i]}
                        onChange={(e) => handleChange(e, i)}
                        size="small"
                        sx={inputStyle}
                      />
                    )}

                    <img
                      alt="arrow"
                      src={Arrow}
                      style={{
                        width: "150px",
                        height: "28px",
                        marginTop: 4,
                      }}
                    />
                  </FormControl>
                ))}
              </Box>
            </Paper>

            {/* MODEL CARD */}
            <Box sx={{ width: 355 }}>
              <Paper
                elevation={0}
                sx={{
                  ...cardStyle,
                  height: 310,
                  borderRadius: "24px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 700,
                    color: "#0078c9",
                    mb: 4,
                  }}
                >
                  SelexMB Trained Model
                </Typography>

                <img
                  alt="model"
                  src={model}
                  style={{
                    objectFit: "contain",
                    height: "130px",
                  }}
                />
              </Paper>

              <Button
                onClick={checkinput}
                disabled={!props.editAccess}
                variant="contained"
                sx={{
                  mt: 2,
                  width: 145,
                  height: 40,
                  fontSize: "12px",
                  fontWeight: 600,
                  borderRadius: "12px",
                  textTransform: "none",
                  backgroundColor: Projectcolors.primary,
                  "&:hover": {
                    backgroundColor: "#9e0b22",
                  },
                }}
              >
                Run SelexMB
              </Button>
            </Box>

            {/* DEPENDENT VARIABLES */}
            <Paper
              elevation={0}
              sx={{
                ...cardStyle,
                position: "relative",
                width: 390,
                height: 330,
                p: 2,
                pt: 5,
              }}
            >
              <Box sx={sectionTitleStyle}>Dependent Variables</Box>

              <Box sx={{ height: 275, overflowY: "auto", pr: 1 }}>
                {(fp.length > 0 ? fp[1] : dependent).map((item, i) => (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 2,
                      p: 1,
                      borderRadius: "12px",
                      "&:hover": {
                        bgcolor: "#f8fbff",
                      },
                    }}
                  >
                    <Box sx={{ width: "58%" }}>
                      <Typography sx={{ fontSize: "11px" }}>
                        {fp.length > 0 ? item[1] : `${item} (${unitsde[i]})`}
                      </Typography>

                      <img
                        alt="arrow"
                        src={Arrow}
                        style={{
                          width: "160px",
                          height: "28px",
                          marginTop: 2,
                        }}
                      />
                    </Box>

                    <OutlinedInput
                      value={predicted ? predicted[i] : ""}
                      placeholder=" "
                      size="small"
                      sx={inputStyle}
                    />
                  </Box>
                ))}
              </Box>
            </Paper>
          </Box>

          {/* PROGRESS */}
          <Box sx={{ mt: 2, width: "98%" }}>
            {modalTraining && <LinearProgressWithLabel value={progress} />}
            {trained && <LinearProgressWithLabel value={100} />}
          </Box>
        </Box>
      </Paper>

      {/* SNAPSHOT CARD */}
      <Paper
        elevation={0}
        sx={{
          ...cardStyle2,
          width: 450,
          height: 515,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            bgcolor: Projectcolors.primary,
            color: "white",
            px: 2,
            py: 1.3,
          }}
        >
          <Typography sx={{ fontSize: 15, fontWeight: 600 }}>
            Selected Snapshot
          </Typography>
        </Box>

        <Box sx={{ p: 2 }}>
          <Paper
            elevation={0}
            sx={{
              height: 430,
              borderRadius: "18px",
              border: "1px solid #d9e9f7",
              overflow: "auto",
              p: 2,
              background: "#fff",
            }}
          >
            <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
              Snapshot {selectedsnapshot}
            </Typography>

            <Divider sx={{ my: 1 }} />

            <Typography sx={{ fontSize: 11, mb: 1 }}>
              Total Variable : {snapdetails.length}
            </Typography>

            {snapdetails.length > 0 &&
              typeof snapdetails[0][1] !== "string" && (
                <Box
                  sx={{
                    p: 1.2,
                    mb: 1.5,
                    borderRadius: "12px",
                    bgcolor: "#f8fbff",
                    border: "1px solid #e4f0fa",
                  }}
                >
                  <Typography sx={{ fontSize: 11 }}>
                    Train Data % : {snapdetails[0][9][0]}
                  </Typography>
                  <Typography sx={{ fontSize: 11 }}>
                    No of Layers : {snapdetails[0][9][1]}
                  </Typography>
                  <Typography sx={{ fontSize: 11 }}>
                    No of Epochs : {snapdetails[0][9][2]}
                  </Typography>
                  <Typography sx={{ fontSize: 11 }}>
                    Batch Size : {snapdetails[0][9][3]}
                  </Typography>
                </Box>
              )}

            {snapdetails.map((item, i) => (
              <Box
                key={i}
                sx={{
                  p: 1.2,
                  mb: 1.5,
                  borderRadius: "12px",
                  bgcolor: "#fff",
                  border: "1px solid #edf4fa",
                  "&:hover": {
                    bgcolor: "#f8fbff",
                  },
                }}
              >
                <Typography sx={{ fontSize: 11 }}>
                  Dependent Variable : {item[0]}
                </Typography>

                <Typography sx={{ fontSize: 11 }}>
                  Machine Learning Method :{" "}
                  {typeof item[1] === "string" ? item[1] : "ANN"}
                </Typography>

                {cat[i] === false ? (
                  <>
                    <Typography sx={{ fontSize: 11 }}>
                      R2(Training) Score : {item[5]}
                    </Typography>
                    <Typography sx={{ fontSize: 11 }}>
                      R2(Training) - RMSE : {item[6]}
                    </Typography>

                    {!timeseries && (
                      <>
                        <Typography sx={{ fontSize: 11 }}>
                          R2(Testing) Score : {item[7]}
                        </Typography>
                        <Typography sx={{ fontSize: 11 }}>
                          R2(Testing) - RMSE : {item[8]}
                        </Typography>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <Typography sx={{ fontSize: 11 }}>
                      Precision : {item[6][0]}
                    </Typography>
                    <Typography sx={{ fontSize: 11 }}>
                      Recall : {item[6][1]}
                    </Typography>
                    <Typography sx={{ fontSize: 11 }}>
                      F1 Score : {item[7]}
                    </Typography>
                    <Typography sx={{ fontSize: 11 }}>
                      Accuracy : {item[8]}
                    </Typography>
                  </>
                )}
              </Box>
            ))}
          </Paper>
        </Box>
      </Paper>
    </Box>

    {getLoader ? <GlobalLoader /> : null}
  </Box>
);
}

export default Deploy;
